var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "step-2" }, [
    _c("div", { staticClass: "details" }, [
      _c("div", { staticClass: "date" }, [
        _vm._v("\n      " + _vm._s(_vm.formattedData.dateInLocale) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "time" }, [
        _vm._v("\n      " + _vm._s(_vm.formattedData.time) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "timezone" }, [
        _c("i", { staticClass: "isif isif-globe" }),
        _vm._v(_vm._s(_vm.bookings.timezone) + "\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "form",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "fields" },
          _vm._l(_vm.fields, function (field) {
            return _c("div", { key: field.key, staticClass: "field" }, [
              _c("label", { attrs: { for: field.key } }, [
                _vm._v("\n          " + _vm._s(field.label) + "\n          "),
                field.required
                  ? _c(
                      "em",
                      {
                        staticClass: "required",
                        attrs: { title: _vm.$t("booking.requiredField") },
                      },
                      [_vm._v("*")]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "field-wrap" },
                [
                  field.type === "timerange"
                    ? [
                        _c("div", { staticClass: "time-wrap" }, [
                          _c("div", { staticClass: "date" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.formattedData.date) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: field.value.from,
                                  expression: "field.value.from",
                                },
                              ],
                              staticClass: "input-inner",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    field.value,
                                    "from",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            _vm._l(_vm.startTimeOptions, function (option) {
                              return _c(
                                "option",
                                {
                                  key: "from-" + option,
                                  domProps: { value: option },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(option) +
                                      "\n                "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "label concat" }, [
                          _vm._v("\n              ~\n            "),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "time-wrap" }, [
                          _c("div", { staticClass: "date" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.isEndTimeCrossDay
                                    ? _vm.formattedData.dateAfterMidnight
                                    : _vm.formattedData.date
                                ) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: field.value.to,
                                  expression: "field.value.to",
                                },
                              ],
                              staticClass: "input-inner",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    field.value,
                                    "to",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            _vm._l(_vm.endTimeOptions, function (option) {
                              return _c(
                                "option",
                                {
                                  key: "to-" + option,
                                  domProps: { value: option },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(option) +
                                      "\n                "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]
                    : field.type === "textarea"
                    ? _c(
                        "textarea",
                        _vm._b(
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: field.value,
                                expression: "field.value",
                              },
                            ],
                            attrs: {
                              id: field.key,
                              name: field.key,
                              required: field.required,
                              title: field.required
                                ? _vm.$t("booking.requiredField")
                                : "",
                              rows: "3",
                            },
                            domProps: { value: field.value },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(field, "value", $event.target.value)
                              },
                            },
                          },
                          "textarea",
                          field.attrs || {},
                          false
                        )
                      )
                    : field.type === "multi-inputs"
                    ? _c(
                        "div",
                        { staticClass: "multi-inputs" },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                id: field.key,
                                name: field.key,
                                type: field.type,
                                title: field.required
                                  ? _vm.$t("booking.requiredField")
                                  : "",
                              },
                              nativeOn: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                  return _vm.addInput(
                                    _vm.currentEmailInput,
                                    false
                                  )
                                },
                              },
                              model: {
                                value: _vm.currentEmailInput,
                                callback: function ($$v) {
                                  _vm.currentEmailInput = $$v
                                },
                                expression: "currentEmailInput",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: { slot: "append", icon: "el-icon-plus" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addInput(
                                      _vm.currentEmailInput,
                                      false
                                    )
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("tag-list", {
                            staticClass: "mt-2",
                            attrs: { value: _vm.emails },
                            on: { remove: _vm.updateTagList },
                          }),
                        ],
                        1
                      )
                    : field.type === "checkbox"
                    ? _c(
                        "input",
                        _vm._b(
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: field.value,
                                expression: "field.value",
                              },
                            ],
                            attrs: {
                              id: field.key,
                              name: field.key,
                              required: field.required,
                              title: field.required
                                ? _vm.$t("booking.requiredField")
                                : "",
                              type: "checkbox",
                            },
                            domProps: {
                              checked: Array.isArray(field.value)
                                ? _vm._i(field.value, null) > -1
                                : field.value,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = field.value,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        field,
                                        "value",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        field,
                                        "value",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(field, "value", $$c)
                                }
                              },
                            },
                          },
                          "input",
                          field.attrs || {},
                          false
                        )
                      )
                    : field.type === "radio"
                    ? _c(
                        "input",
                        _vm._b(
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: field.value,
                                expression: "field.value",
                              },
                            ],
                            attrs: {
                              id: field.key,
                              name: field.key,
                              required: field.required,
                              title: field.required
                                ? _vm.$t("booking.requiredField")
                                : "",
                              type: "radio",
                            },
                            domProps: { checked: _vm._q(field.value, null) },
                            on: {
                              change: function ($event) {
                                return _vm.$set(field, "value", null)
                              },
                            },
                          },
                          "input",
                          field.attrs || {},
                          false
                        )
                      )
                    : _c(
                        "input",
                        _vm._b(
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: field.value,
                                expression: "field.value",
                              },
                            ],
                            attrs: {
                              id: field.key,
                              name: field.key,
                              required: field.required,
                              title: field.required
                                ? _vm.$t("booking.requiredField")
                                : "",
                              type: field.type,
                            },
                            domProps: { value: field.value },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(field, "value", $event.target.value)
                              },
                            },
                          },
                          "input",
                          field.attrs || {},
                          false
                        )
                      ),
                ],
                2
              ),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "footer" }, [
          _c(
            "div",
            { staticClass: "message" },
            [
              _vm.submitError
                ? [
                    _c("span", [_vm._v(_vm._s(_vm.$t("booking.submitError")))]),
                    _vm._v(" "),
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.submitError) },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "submit",
              attrs: { type: "submit", disabled: _vm.isBusy },
            },
            [
              _vm.isBusy
                ? _c("span", [_vm._v(_vm._s(_vm.$t("booking.pleaseWait")))])
                : _c("span", [_vm._v(_vm._s(_vm.$t("booking.confirm")))]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }